import axios from "axios";
import store from "@/store";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
});

// Request interceptor for API calls
api.interceptors.request.use(
  (config) => {
    store.commit("master/setLoading", true);
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    store.commit("master/setLoading", false);
    return Promise.reject(error);
  },
);

// Response interceptor for API calls
api.interceptors.response.use(
  (response) => {
    store.commit("master/setLoading", false);
    return response;
  },
  (error) => {
    store.commit("master/setLoading", false);
    // Only redirect to logout if it's a 401 and NOT a login request
    if (error.response && error.response.status === 401 && !error.config.url.includes('/auth/login')) {
      store.dispatch("auth/logout");
    }
    return Promise.reject(error);
  },
);

export default api;
